import { render, staticRenderFns } from "./comp2.vue?vue&type=template&id=d58333ea&scoped=true"
import script from "./comp2.vue?vue&type=script&lang=ts"
export * from "./comp2.vue?vue&type=script&lang=ts"
import style0 from "./comp2.vue?vue&type=style&index=0&id=d58333ea&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d58333ea",
  null
  
)

export default component.exports